var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreyCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.9 42.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a8a8a8",
    d: "M21.45,0C9.6,0,0,9.6,0,21.45s9.6,21.45,21.45,21.45,21.45-9.6,21.45-21.45S33.29,0,21.45,0ZM32.29,29.64c.73.73.73,1.92,0,2.65-.37.37-.85.55-1.33.55s-.96-.18-1.33-.55l-8.19-8.19-8.19,8.19c-.37.37-.85.55-1.33.55s-.96-.18-1.33-.55c-.73-.73-.73-1.92,0-2.65l8.19-8.19-8.19-8.19c-.73-.73-.73-1.92,0-2.65.73-.73,1.92-.73,2.65,0l8.19,8.19,8.19-8.19c.73-.73,1.92-.73,2.65,0s.73,1.92,0,2.65l-8.19,8.19,8.19,8.19Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyCross);
export default __webpack_public_path__ + "static/media/grey-cross.e3fe78d67e152337effa6d807834a06b.svg";
export { ForwardRef as ReactComponent };